import React from "react";

function Modal({ open, close, title = "", children = "" }) {
    return (
        <>
            <div
                style={{ background: "#0000008a" }}
                className={`${
                    open ? "" : "hidden"
                } overflow-y-auto overflow-x-hidden fixed flex z-50 w-full md:inset-0 h-modal md:h-full justify-center items-center`}
            >
                <div className="relative p-4 w-full max-w-md h-full md:h-auto mt-24 mb-4">
                    {/* Modal content */}
                    <div className="relative bg-white rounded-lg shadow">
                        <button
                            onClick={close}
                            type="button"
                            className="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-800 dark:hover:text-white"
                            data-modal-toggle="authentication-modal"
                        >
                            <svg
                                aria-hidden="true"
                                className="w-5 h-5"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    fillRule="evenodd"
                                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                    clipRule="evenodd"
                                />
                            </svg>
                            <span className="sr-only">Close modal</span>
                        </button>
                        <div className="py-6 px-6 lg:px-8">
                            <h3 className="mb-4 text-xl font-medium text-gray-900 dark:text-white">
                                {title}
                            </h3>
                            {children}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Modal;
